var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthorized)?_c('router-link',{attrs:{"to":_vm.to,"replace":_vm.replace,"append":_vm.append,"tag":_vm.tag,"exact":_vm.exact,"event":_vm.event,"active-class":_vm.activeClass,"exact-active-class":_vm.exactActiveClass}},[_c('a',[_vm._v(_vm._s(_vm.$t(_vm.msg_slug)))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3b321a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/RouterLinkGuard.vue
// module id = 807
// module chunks = 0